const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

const formatTimeStamp = ts => {
    const dt = new Date(ts);
    return `${dt.toLocaleString("en-GB", options)} at ${dt.toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' })}`;
}

export {
    formatTimeStamp
}